import tw from 'twin.macro';

const Copyright = tw.p`text-sm text-gray-100 text-center`;

export default Copyright;
